import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import GestureHandler from "./GestureHandler";

var IndiscreteGestureHandler = function (_GestureHandler) {
  _inherits(IndiscreteGestureHandler, _GestureHandler);

  var _super = _createSuper(IndiscreteGestureHandler);

  function IndiscreteGestureHandler() {
    _classCallCheck(this, IndiscreteGestureHandler);

    return _super.apply(this, arguments);
  }

  _createClass(IndiscreteGestureHandler, [{
    key: "updateGestureConfig",
    value: function updateGestureConfig(_ref) {
      var _ref$minPointers = _ref.minPointers,
          minPointers = _ref$minPointers === void 0 ? 2 : _ref$minPointers,
          _ref$maxPointers = _ref.maxPointers,
          maxPointers = _ref$maxPointers === void 0 ? 2 : _ref$maxPointers,
          props = _objectWithoutProperties(_ref, ["minPointers", "maxPointers"]);

      return _get(_getPrototypeOf(IndiscreteGestureHandler.prototype), "updateGestureConfig", this).call(this, _objectSpread({
        minPointers: minPointers,
        maxPointers: maxPointers
      }, props));
    }
  }, {
    key: "isGestureEnabledForEvent",
    value: function isGestureEnabledForEvent(_ref2, recognizer, _ref3) {
      var minPointers = _ref2.minPointers,
          maxPointers = _ref2.maxPointers;
      var pointerLength = _ref3.maxPointers;

      if (pointerLength > maxPointers) {
        return {
          failed: true
        };
      }

      var validPointerCount = pointerLength >= minPointers;
      return {
        success: validPointerCount
      };
    }
  }, {
    key: "shouldEnableGestureOnSetup",
    get: function get() {
      return false;
    }
  }]);

  return IndiscreteGestureHandler;
}(GestureHandler);

export default IndiscreteGestureHandler;